
import React, { useState, useEffect } from 'react';
import { NavItem } from '../types';

interface HeaderProps {
  onCtaClick: () => void;
  isLanding: boolean;
}

const Header: React.FC<HeaderProps> = ({ onCtaClick, isLanding }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems: NavItem[] = [
    { label: '고민 해결', href: '#problem' },
    { label: '솔루션', href: '#solution' },
    { label: '수강 후기', href: '#social' },
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isLanding ? 'bg-[#FAF7F2]/80 backdrop-blur-lg shadow-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between">
        <a href="/" className="flex items-center space-x-2">
          <div className="w-10 h-10 bg-pink-200 rounded-lg flex items-center justify-center font-black text-pink-900 text-xl shadow-sm">T</div>
          <span className={`text-xl font-bold tracking-tight ${isScrolled || !isLanding ? 'text-slate-800' : 'text-slate-900'}`}>
            <span className="text-slate-900">TOEFL</span> <span className="text-pink-300">30 JUMP</span>
          </span>
        </a>

        {isLanding && (
          <nav className="hidden md:flex items-center space-x-10">
            {navItems.map((item) => (
              <a 
                key={item.label} 
                href={item.href}
                className={`text-sm font-semibold transition-colors ${
                  isScrolled ? 'text-slate-500 hover:text-pink-400' : 'text-slate-600 hover:text-slate-900'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}

        <button 
          onClick={onCtaClick}
          className="bg-pink-300 text-white px-5 py-2.5 rounded-full text-sm font-bold hover:bg-pink-400 transition-all shadow-md active:scale-95"
        >
          무료 상담 신청
        </button>
      </div>
    </header>
  );
};

export default Header;
